!function (n, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Parsimmon = t() : n.Parsimmon = t();
}("undefined" != typeof self ? self : this, function () {
  return function (n) {
    var t = {};

    function r(e) {
      if (t[e]) return t[e].exports;
      var u = t[e] = {
        i: e,
        l: !1,
        exports: {}
      };
      return n[e].call(u.exports, u, u.exports, r), u.l = !0, u.exports;
    }

    return r.m = n, r.c = t, r.d = function (n, t, e) {
      r.o(n, t) || Object.defineProperty(n, t, {
        configurable: !1,
        enumerable: !0,
        get: e
      });
    }, r.r = function (n) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, r.n = function (n) {
      var t = n && n.__esModule ? function () {
        return n.default;
      } : function () {
        return n;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (n, t) {
      return Object.prototype.hasOwnProperty.call(n, t);
    }, r.p = "", r(r.s = 0);
  }([function (n, t, r) {
    "use strict";

    function e(n) {
      if (!(this instanceof e)) return new e(n);
      this._ = n;
    }

    var u = e.prototype;

    function o(n, t) {
      for (var r = 0; r < n; r++) {
        t(r);
      }
    }

    function i(n, t, r) {
      return function (n, t) {
        o(t.length, function (r) {
          n(t[r], r, t);
        });
      }(function (r, e, u) {
        t = n(t, r, e, u);
      }, r), t;
    }

    function f(n, t) {
      return i(function (t, r, e, u) {
        return t.concat([n(r, e, u)]);
      }, [], t);
    }

    function a(n, t) {
      var r = {
        v: 0,
        buf: t
      };
      return o(n, function () {
        var n;
        r = {
          v: r.v << 1 | (n = r.buf, n[0] >> 7),
          buf: function (n) {
            var t = i(function (n, t, r, e) {
              return n.concat(r === e.length - 1 ? Buffer.from([t, 0]).readUInt16BE(0) : e.readUInt16BE(r));
            }, [], n);
            return Buffer.from(f(function (n) {
              return (n << 1 & 65535) >> 8;
            }, t));
          }(r.buf)
        };
      }), r;
    }

    function c() {
      return "undefined" != typeof Buffer;
    }

    function s() {
      if (!c()) throw new Error("Buffer global does not exist; please use webpack if you need to parse Buffers in the browser.");
    }

    function l(n) {
      s();
      var t = i(function (n, t) {
        return n + t;
      }, 0, n);
      if (t % 8 != 0) throw new Error("The bits [" + n.join(", ") + "] add up to " + t + " which is not an even number of bytes; the total should be divisible by 8");
      var r,
          u = t / 8,
          o = (r = function r(n) {
        return n > 48;
      }, i(function (n, t) {
        return n || (r(t) ? t : n);
      }, null, n));
      if (o) throw new Error(o + " bit range requested exceeds 48 bit (6 byte) Number max.");
      return new e(function (t, r) {
        var e = u + r;
        return e > t.length ? x(r, u.toString() + " bytes") : b(e, i(function (n, t) {
          var r = a(t, n.buf);
          return {
            coll: n.coll.concat(r.v),
            buf: r.buf
          };
        }, {
          coll: [],
          buf: t.slice(r, e)
        }, n).coll);
      });
    }

    function h(n, t) {
      return new e(function (r, e) {
        return s(), e + t > r.length ? x(e, t + " bytes for " + n) : b(e + t, r.slice(e, e + t));
      });
    }

    function p(n, t) {
      if ("number" != typeof (r = t) || Math.floor(r) !== r || t < 0 || t > 6) throw new Error(n + " requires integer length in range [0, 6].");
      var r;
    }

    function d(n) {
      return p("uintBE", n), h("uintBE(" + n + ")", n).map(function (t) {
        return t.readUIntBE(0, n);
      });
    }

    function v(n) {
      return p("uintLE", n), h("uintLE(" + n + ")", n).map(function (t) {
        return t.readUIntLE(0, n);
      });
    }

    function g(n) {
      return p("intBE", n), h("intBE(" + n + ")", n).map(function (t) {
        return t.readIntBE(0, n);
      });
    }

    function m(n) {
      return p("intLE", n), h("intLE(" + n + ")", n).map(function (t) {
        return t.readIntLE(0, n);
      });
    }

    function y(n) {
      return n instanceof e;
    }

    function E(n) {
      return "[object Array]" === {}.toString.call(n);
    }

    function w(n) {
      return c() && Buffer.isBuffer(n);
    }

    function b(n, t) {
      return {
        status: !0,
        index: n,
        value: t,
        furthest: -1,
        expected: []
      };
    }

    function x(n, t) {
      return E(t) || (t = [t]), {
        status: !1,
        index: -1,
        value: null,
        furthest: n,
        expected: t
      };
    }

    function B(n, t) {
      if (!t) return n;
      if (n.furthest > t.furthest) return n;
      var r = n.furthest === t.furthest ? function (n, t) {
        for (var r = {}, e = 0; e < n.length; e++) {
          r[n[e]] = !0;
        }

        for (var u = 0; u < t.length; u++) {
          r[t[u]] = !0;
        }

        var o = [];

        for (var i in r) {
          ({}).hasOwnProperty.call(r, i) && o.push(i);
        }

        return o.sort(), o;
      }(n.expected, t.expected) : t.expected;
      return {
        status: n.status,
        index: n.index,
        value: n.value,
        furthest: t.furthest,
        expected: r
      };
    }

    function j(n, t) {
      if (w(n)) return {
        offset: t,
        line: -1,
        column: -1
      };
      var r = n.slice(0, t).split("\n");
      return {
        offset: t,
        line: r.length,
        column: r[r.length - 1].length + 1
      };
    }

    function O(n) {
      if (!y(n)) throw new Error("not a parser: " + n);
    }

    function L(n, t) {
      return "string" == typeof n ? n.charAt(t) : n[t];
    }

    function _(n) {
      if ("number" != typeof n) throw new Error("not a number: " + n);
    }

    function S(n) {
      if ("function" != typeof n) throw new Error("not a function: " + n);
    }

    function k(n) {
      if ("string" != typeof n) throw new Error("not a string: " + n);
    }

    var P = 2,
        q = 3,
        I = 8,
        A = 5 * I,
        F = 4 * I,
        M = "  ";

    function z(n, t) {
      return new Array(t + 1).join(n);
    }

    function R(n, t, r) {
      var e = t - n.length;
      return e <= 0 ? n : z(r, e) + n;
    }

    function U(n, t, r, e) {
      return {
        from: n - t > 0 ? n - t : 0,
        to: n + r > e ? e : n + r
      };
    }

    function W(n, t) {
      var r,
          e,
          u,
          o,
          a,
          c = t.index,
          s = c.offset,
          l = 1;
      if (s === n.length) return "Got the end of the input";

      if (w(n)) {
        var h = s - s % I,
            p = s - h,
            d = U(h, A, F + I, n.length),
            v = f(function (n) {
          return f(function (n) {
            return R(n.toString(16), 2, "0");
          }, n);
        }, function (n, t) {
          var r = n.length,
              e = [],
              u = 0;
          if (r <= t) return [n.slice()];

          for (var o = 0; o < r; o++) {
            e[u] || e.push([]), e[u].push(n[o]), (o + 1) % t == 0 && u++;
          }

          return e;
        }(n.slice(d.from, d.to).toJSON().data, I));
        o = function (n) {
          return 0 === n.from && 1 === n.to ? {
            from: n.from,
            to: n.to
          } : {
            from: n.from / I,
            to: Math.floor(n.to / I)
          };
        }(d), e = h / I, r = 3 * p, p >= 4 && (r += 1), l = 2, u = f(function (n) {
          return n.length <= 4 ? n.join(" ") : n.slice(0, 4).join(" ") + "  " + n.slice(4).join(" ");
        }, v), (a = (8 * (o.to > 0 ? o.to - 1 : o.to)).toString(16).length) < 2 && (a = 2);
      } else {
        var g = n.split(/\r\n|[\n\r\u2028\u2029]/);
        r = c.column - 1, e = c.line - 1, o = U(e, P, q, g.length), u = g.slice(o.from, o.to), a = o.to.toString().length;
      }

      var m = e - o.from;
      return w(n) && (a = (8 * (o.to > 0 ? o.to - 1 : o.to)).toString(16).length) < 2 && (a = 2), i(function (t, e, u) {
        var i,
            f = u === m,
            c = f ? "> " : M;
        return i = w(n) ? R((8 * (o.from + u)).toString(16), a, "0") : R((o.from + u + 1).toString(), a, " "), [].concat(t, [c + i + " | " + e], f ? [M + z(" ", a) + " | " + R("", r, " ") + z("^", l)] : []);
      }, [], u).join("\n");
    }

    function D(n, t) {
      return ["\n", "-- PARSING FAILED " + z("-", 50), "\n\n", W(n, t), "\n\n", (r = t.expected, 1 === r.length ? "Expected:\n\n" + r[0] : "Expected one of the following: \n\n" + r.join(", ")), "\n"].join("");
      var r;
    }

    function N(n) {
      var t = "" + n;
      return t.slice(t.lastIndexOf("/") + 1);
    }

    function G() {
      for (var n = [].slice.call(arguments), t = n.length, r = 0; r < t; r += 1) {
        O(n[r]);
      }

      return e(function (r, e) {
        for (var u, o = new Array(t), i = 0; i < t; i += 1) {
          if (!(u = B(n[i]._(r, e), u)).status) return u;
          o[i] = u.value, e = u.index;
        }

        return B(b(e, o), u);
      });
    }

    function J() {
      var n = [].slice.call(arguments);
      if (0 === n.length) throw new Error("seqMap needs at least one argument");
      var t = n.pop();
      return S(t), G.apply(null, n).map(function (n) {
        return t.apply(null, n);
      });
    }

    function T() {
      var n = [].slice.call(arguments),
          t = n.length;
      if (0 === t) return X("zero alternates");

      for (var r = 0; r < t; r += 1) {
        O(n[r]);
      }

      return e(function (t, r) {
        for (var e, u = 0; u < n.length; u += 1) {
          if ((e = B(n[u]._(t, r), e)).status) return e;
        }

        return e;
      });
    }

    function V(n, t) {
      return C(n, t).or(Q([]));
    }

    function C(n, t) {
      return O(n), O(t), J(n, t.then(n).many(), function (n, t) {
        return [n].concat(t);
      });
    }

    function H(n) {
      k(n);
      var t = "'" + n + "'";
      return e(function (r, e) {
        var u = e + n.length,
            o = r.slice(e, u);
        return o === n ? b(u, o) : x(e, t);
      });
    }

    function K(n, t) {
      !function (n) {
        if (!(n instanceof RegExp)) throw new Error("not a regexp: " + n);

        for (var t = N(n), r = 0; r < t.length; r++) {
          var e = t.charAt(r);
          if ("i" !== e && "m" !== e && "u" !== e) throw new Error('unsupported regexp flag "' + e + '": ' + n);
        }
      }(n), arguments.length >= 2 ? _(t) : t = 0;

      var r = function (n) {
        return RegExp("^(?:" + n.source + ")", N(n));
      }(n),
          u = "" + n;

      return e(function (n, e) {
        var o = r.exec(n.slice(e));

        if (o) {
          if (0 <= t && t <= o.length) {
            var i = o[0],
                f = o[t];
            return b(e + i.length, f);
          }

          return x(e, "valid match group (0 to " + o.length + ") in " + u);
        }

        return x(e, u);
      });
    }

    function Q(n) {
      return e(function (t, r) {
        return b(r, n);
      });
    }

    function X(n) {
      return e(function (t, r) {
        return x(r, n);
      });
    }

    function Y(n) {
      if (y(n)) return e(function (t, r) {
        var e = n._(t, r);

        return e.index = r, e.value = "", e;
      });
      if ("string" == typeof n) return Y(H(n));
      if (n instanceof RegExp) return Y(K(n));
      throw new Error("not a string, regexp, or parser: " + n);
    }

    function Z(n) {
      return O(n), e(function (t, r) {
        var e = n._(t, r),
            u = t.slice(r, e.index);

        return e.status ? x(r, 'not "' + u + '"') : b(r, null);
      });
    }

    function $(n) {
      return S(n), e(function (t, r) {
        var e = L(t, r);
        return r < t.length && n(e) ? b(r + 1, e) : x(r, "a character/byte matching " + n);
      });
    }

    function nn(n, t) {
      arguments.length < 2 && (t = n, n = void 0);
      var r = e(function (n, e) {
        return r._ = t()._, r._(n, e);
      });
      return n ? r.desc(n) : r;
    }

    function tn() {
      return X("fantasy-land/empty");
    }

    u.parse = function (n) {
      if ("string" != typeof n && !w(n)) throw new Error(".parse must be called with a string or Buffer as its argument");

      var t = this.skip(on)._(n, 0);

      return t.status ? {
        status: !0,
        value: t.value
      } : {
        status: !1,
        index: j(n, t.furthest),
        expected: t.expected
      };
    }, u.tryParse = function (n) {
      var t = this.parse(n);
      if (t.status) return t.value;
      var r = D(n, t),
          e = new Error(r);
      throw e.type = "ParsimmonError", e.result = t, e;
    }, u.assert = function (n, t) {
      return this.chain(function (r) {
        return n(r) ? Q(r) : X(t);
      });
    }, u.or = function (n) {
      return T(this, n);
    }, u.trim = function (n) {
      return this.wrap(n, n);
    }, u.wrap = function (n, t) {
      return J(n, this, t, function (n, t) {
        return t;
      });
    }, u.thru = function (n) {
      return n(this);
    }, u.then = function (n) {
      return O(n), G(this, n).map(function (n) {
        return n[1];
      });
    }, u.many = function () {
      var n = this;
      return e(function (t, r) {
        for (var e = [], u = void 0;;) {
          if (!(u = B(n._(t, r), u)).status) return B(b(r, e), u);
          if (r === u.index) throw new Error("infinite loop detected in .many() parser --- calling .many() on a parser which can accept zero characters is usually the cause");
          r = u.index, e.push(u.value);
        }
      });
    }, u.tieWith = function (n) {
      return k(n), this.map(function (t) {
        if (function (n) {
          if (!E(n)) throw new Error("not an array: " + n);
        }(t), t.length) {
          k(t[0]);

          for (var r = t[0], e = 1; e < t.length; e++) {
            k(t[e]), r += n + t[e];
          }

          return r;
        }

        return "";
      });
    }, u.tie = function () {
      return this.tieWith("");
    }, u.times = function (n, t) {
      var r = this;
      return arguments.length < 2 && (t = n), _(n), _(t), e(function (e, u) {
        for (var o = [], i = void 0, f = void 0, a = 0; a < n; a += 1) {
          if (f = B(i = r._(e, u), f), !i.status) return f;
          u = i.index, o.push(i.value);
        }

        for (; a < t && (f = B(i = r._(e, u), f), i.status); a += 1) {
          u = i.index, o.push(i.value);
        }

        return B(b(u, o), f);
      });
    }, u.result = function (n) {
      return this.map(function () {
        return n;
      });
    }, u.atMost = function (n) {
      return this.times(0, n);
    }, u.atLeast = function (n) {
      return J(this.times(n), this.many(), function (n, t) {
        return n.concat(t);
      });
    }, u.map = function (n) {
      S(n);
      var t = this;
      return e(function (r, e) {
        var u = t._(r, e);

        return u.status ? B(b(u.index, n(u.value)), u) : u;
      });
    }, u.contramap = function (n) {
      S(n);
      var t = this;
      return e(function (r, e) {
        var u = t.parse(n(r.slice(e)));
        return u.status ? b(e + r.length, u.value) : u;
      });
    }, u.promap = function (n, t) {
      return S(n), S(t), this.contramap(n).map(t);
    }, u.skip = function (n) {
      return G(this, n).map(function (n) {
        return n[0];
      });
    }, u.mark = function () {
      return J(rn, this, rn, function (n, t, r) {
        return {
          start: n,
          value: t,
          end: r
        };
      });
    }, u.node = function (n) {
      return J(rn, this, rn, function (t, r, e) {
        return {
          name: n,
          value: r,
          start: t,
          end: e
        };
      });
    }, u.sepBy = function (n) {
      return V(this, n);
    }, u.sepBy1 = function (n) {
      return C(this, n);
    }, u.lookahead = function (n) {
      return this.skip(Y(n));
    }, u.notFollowedBy = function (n) {
      return this.skip(Z(n));
    }, u.desc = function (n) {
      E(n) || (n = [n]);
      var t = this;
      return e(function (r, e) {
        var u = t._(r, e);

        return u.status || (u.expected = n), u;
      });
    }, u.fallback = function (n) {
      return this.or(Q(n));
    }, u.ap = function (n) {
      return J(n, this, function (n, t) {
        return n(t);
      });
    }, u.chain = function (n) {
      var t = this;
      return e(function (r, e) {
        var u = t._(r, e);

        return u.status ? B(n(u.value)._(r, u.index), u) : u;
      });
    }, u.concat = u.or, u.empty = tn, u.of = Q, u["fantasy-land/ap"] = u.ap, u["fantasy-land/chain"] = u.chain, u["fantasy-land/concat"] = u.concat, u["fantasy-land/empty"] = u.empty, u["fantasy-land/of"] = u.of, u["fantasy-land/map"] = u.map;
    var rn = e(function (n, t) {
      return b(t, j(n, t));
    }),
        en = e(function (n, t) {
      return t >= n.length ? x(t, "any character/byte") : b(t + 1, L(n, t));
    }),
        un = e(function (n, t) {
      return b(n.length, n.slice(t));
    }),
        on = e(function (n, t) {
      return t < n.length ? x(t, "EOF") : b(t, null);
    }),
        fn = K(/[0-9]/).desc("a digit"),
        an = K(/[0-9]*/).desc("optional digits"),
        cn = K(/[a-z]/i).desc("a letter"),
        sn = K(/[a-z]*/i).desc("optional letters"),
        ln = K(/\s*/).desc("optional whitespace"),
        hn = K(/\s+/).desc("whitespace"),
        pn = H("\r"),
        dn = H("\n"),
        vn = H("\r\n"),
        gn = T(vn, dn, pn).desc("newline"),
        mn = T(gn, on);
    e.all = un, e.alt = T, e.any = en, e.cr = pn, e.createLanguage = function (n) {
      var t = {};

      for (var r in n) {
        ({}).hasOwnProperty.call(n, r) && function (r) {
          t[r] = nn(function () {
            return n[r](t);
          });
        }(r);
      }

      return t;
    }, e.crlf = vn, e.custom = function (n) {
      return e(n(b, x));
    }, e.digit = fn, e.digits = an, e.empty = tn, e.end = mn, e.eof = on, e.fail = X, e.formatError = D, e.index = rn, e.isParser = y, e.lazy = nn, e.letter = cn, e.letters = sn, e.lf = dn, e.lookahead = Y, e.makeFailure = x, e.makeSuccess = b, e.newline = gn, e.noneOf = function (n) {
      return $(function (t) {
        return n.indexOf(t) < 0;
      }).desc("none of '" + n + "'");
    }, e.notFollowedBy = Z, e.of = Q, e.oneOf = function (n) {
      for (var t = n.split(""), r = 0; r < t.length; r++) {
        t[r] = "'" + t[r] + "'";
      }

      return $(function (t) {
        return n.indexOf(t) >= 0;
      }).desc(t);
    }, e.optWhitespace = ln, e.Parser = e, e.range = function (n, t) {
      return $(function (r) {
        return n <= r && r <= t;
      }).desc(n + "-" + t);
    }, e.regex = K, e.regexp = K, e.sepBy = V, e.sepBy1 = C, e.seq = G, e.seqMap = J, e.seqObj = function () {
      for (var n, t = {}, r = 0, u = (n = arguments, Array.prototype.slice.call(n)), o = u.length, i = 0; i < o; i += 1) {
        var f = u[i];

        if (!y(f)) {
          if (E(f) && 2 === f.length && "string" == typeof f[0] && y(f[1])) {
            var a = f[0];
            if (Object.prototype.hasOwnProperty.call(t, a)) throw new Error("seqObj: duplicate key " + a);
            t[a] = !0, r++;
            continue;
          }

          throw new Error("seqObj arguments must be parsers or [string, parser] array pairs.");
        }
      }

      if (0 === r) throw new Error("seqObj expects at least one named parser, found zero");
      return e(function (n, t) {
        for (var r, e = {}, i = 0; i < o; i += 1) {
          var f, a;
          if (E(u[i]) ? (f = u[i][0], a = u[i][1]) : (f = null, a = u[i]), !(r = B(a._(n, t), r)).status) return r;
          f && (e[f] = r.value), t = r.index;
        }

        return B(b(t, e), r);
      });
    }, e.string = H, e.succeed = Q, e.takeWhile = function (n) {
      return S(n), e(function (t, r) {
        for (var e = r; e < t.length && n(L(t, e));) {
          e++;
        }

        return b(e, t.slice(r, e));
      });
    }, e.test = $, e.whitespace = hn, e["fantasy-land/empty"] = tn, e["fantasy-land/of"] = Q, e.Binary = {
      bitSeq: l,
      bitSeqObj: function bitSeqObj(n) {
        s();
        var t = {},
            r = 0,
            e = f(function (n) {
          if (E(n)) {
            var e = n;
            if (2 !== e.length) throw new Error("[" + e.join(", ") + "] should be length 2, got length " + e.length);
            if (k(e[0]), _(e[1]), Object.prototype.hasOwnProperty.call(t, e[0])) throw new Error("duplicate key in bitSeqObj: " + e[0]);
            return t[e[0]] = !0, r++, e;
          }

          return _(n), [null, n];
        }, n);
        if (r < 1) throw new Error("bitSeqObj expects at least one named pair, got [" + n.join(", ") + "]");
        var u = f(function (n) {
          return n[0];
        }, e);
        return l(f(function (n) {
          return n[1];
        }, e)).map(function (n) {
          return i(function (n, t) {
            return null !== t[0] && (n[t[0]] = t[1]), n;
          }, {}, f(function (t, r) {
            return [t, n[r]];
          }, u));
        });
      },
      byte: function byte(n) {
        if (s(), _(n), n > 255) throw new Error("Value specified to byte constructor (" + n + "=0x" + n.toString(16) + ") is larger in value than a single byte.");
        var t = (n > 15 ? "0x" : "0x0") + n.toString(16);
        return e(function (r, e) {
          var u = L(r, e);
          return u === n ? b(e + 1, u) : x(e, t);
        });
      },
      buffer: function buffer(n) {
        return h("buffer", n).map(function (n) {
          return Buffer.from(n);
        });
      },
      encodedString: function encodedString(n, t) {
        return h("string", t).map(function (t) {
          return t.toString(n);
        });
      },
      uintBE: d,
      uint8BE: d(1),
      uint16BE: d(2),
      uint32BE: d(4),
      uintLE: v,
      uint8LE: v(1),
      uint16LE: v(2),
      uint32LE: v(4),
      intBE: g,
      int8BE: g(1),
      int16BE: g(2),
      int32BE: g(4),
      intLE: m,
      int8LE: m(1),
      int16LE: m(2),
      int32LE: m(4),
      floatBE: h("floatBE", 4).map(function (n) {
        return n.readFloatBE(0);
      }),
      floatLE: h("floatLE", 4).map(function (n) {
        return n.readFloatLE(0);
      }),
      doubleBE: h("doubleBE", 8).map(function (n) {
        return n.readDoubleBE(0);
      }),
      doubleLE: h("doubleLE", 8).map(function (n) {
        return n.readDoubleLE(0);
      })
    }, n.exports = e;
  }]);
});